
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"55","height":"40","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M46.2 17.473c.352-.92.55-1.925.55-2.973a8.252 8.252 0 00-8.25-8.25 8.208 8.208 0 00-4.58 1.392C31.54 3.517 27.096.75 22 .75 14.403.75 8.25 6.903 8.25 14.5c0 .232.009.464.017.696C3.455 16.89 0 21.478 0 26.875 0 33.707 5.543 39.25 12.375 39.25H44c6.076 0 11-4.924 11-11 0-5.32-3.781-9.762-8.8-10.777zM33.808 22.75h-5.62v9.625c0 .756-.62 1.375-1.375 1.375h-4.125a1.379 1.379 0 01-1.375-1.375V22.75h-5.62c-1.23 0-1.84-1.478-.972-2.346l9.058-9.058a1.38 1.38 0 011.942 0l9.058 9.058c.868.868.25 2.346-.971 2.346z","fill":"#89BEFA"}})])
          )
        }
      }
    